module.exports = __webpack_public_path__ + "static/media/icon-about.943040c4.svg";